import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
//@ts-ignore
import * as compose from 'lodash.flowright';
import { Image } from 'semantic-ui-react';

import Main from '../../layouts/Main';
import { __ } from '../../lib/I18n';
import { asset } from '../../lib/Util';
import LoginForm from '../../components/Login/Form';

class LoginScreen extends React.Component {
  render() {
    return (
      <Main className="landing" noHeader noSideMenu>
        <div style={{ position: 'fixed', top: '2%', left: '45%' }}>
          <Image size="small" src={asset('classapp-logo.svg')} />
        </div>
        <div className="content" style={{ marginTop: '10%', marginLeft: '20%', transform: 'translateX(-10%)', maxWidth: '23rem', minWidth: '18rem', width: '100%', display: 'flex' }}>
          <div>
            <h1 className="title" style={{ marginBottom: '2rem', width: '25rem' }}>{__('Entrar no Financeiro')}</h1>
            <div>
              <LoginForm router={this.props.router} />
            </div>
          </div>
          <div style={{ paddingLeft: '5rem' }}>
            <img
              alt=""
              src={asset('gif-login.gif')}
              width="497px"
              height="399px"
            />
          </div>
        </div>
      </Main>
    );
  }
}
export default compose(
  inject('store'),
  observer
)(LoginScreen);
